<template>
  <div class="toolbar_format-painter toolbar-icon" @click="formatPainter">
    <custom-icon :class-name="icons.FormatPainter" />
  </div>
</template>

<script>
import { icons } from "../../../utils/icons";
import DesignerMixin from "../DesignerMixin";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  mixins: [DesignerMixin],
  data() {
    return {
      icons: icons,
    };
  },
  methods: {
    async formatPainter() {
      await this.$store.dispatch("cells/formatPainterData", { isFormatPainterActive: true });
    },
  },
};
</script>
